let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9G6yn")).then(() => parcelRequire('d7cx7'));